<template>
    <div class="box">
        <h3>{{$t('profile.company.basic_data')}}</h3>
        <form>
            <div class="box__form" v-if="authStore.userInfo">
                <div>
                    <div class="control control--input">
                        <label for="company" class="control__label"
                        >{{$t('profile.company.name')}}</label
                        >
                        <input
                            type="text"
                            id="company"
                            placeholder="Wpisz nazwę firmy"
                            v-model="company"
                        />
                        <div v-show="errors.company" class="control__error">
                            <div class="control__error-inner">
                                {{errors.company}}
                            </div>
                        </div>
                    </div>
                    <div class="control control--input">
                        <label for="address" class="control__label"
                        >{{$t('profile.company.address')}}</label
                        >
                        <input
                            type="text"
                            id="address"
                            placeholder="Wpisz adres"
                            v-model="address"

                        />
                        <div v-show="errors.address" class="control__error">
                            <div class="control__error-inner">
                                {{errors.address}}
                            </div>
                        </div>
                    </div>
                    <div class="control control--input">
                        <label for="city" class="control__label">{{$t('profile.company.city')}}</label>
                        <input
                            type="text"
                            id="city"
                            placeholder="Wpisz miasto"
                            v-model="city"
                        />
                        <div v-show="errors.city" class="control__error">
                            <div class="control__error-inner">
                                {{errors.city}}
                            </div>
                        </div>
                    </div>
                    <div class="control control--input">
                        <label for="postCode" class="control__label"
                        >{{$t('profile.company.zip_code')}}</label
                        >
                        <input
                            type="text"
                            id="postCode"
                            pattern="^\d{2}-\d{3}$"
                            placeholder="Wpisz kod pocztowy"
                            v-model="zipCode"
                        />
                        <div v-show="errors.zipCode" class="control__error">
                            <div class="control__error-inner">
                                {{errors.zipCode}}
                            </div>
                        </div>
                    </div>
                    <div class="control control--input">
                        <label for="province" class="control__label">{{$t('profile.company.province')}}</label>
                        <input
                            type="text"
                            id="province"
                            placeholder="Wpisz województwo"
                            v-model="province"
                        />
                        <div v-show="errors.province" class="control__error">
                            <div class="control__error-inner">
                                {{errors.province}}
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="control control--input">
                        <label for="nip" class="control__label">{{$t('profile.company.nip')}}</label>
                        <input
                            type="text"
                            id="nip"
                            placeholder="Wpisz NIP firmy"
                            v-model="nip"
                        />
                        <div v-show="errors.nip" class="control__error">
                            <div class="control__error-inner">
                                {{errors.nip}}
                            </div>
                        </div>
                    </div>
                    <div class="control control--input">
                        <label for="nip" class="control__label">{{$t('profile.company.regon')}}</label>
                        <input
                            type="text"
                            id="regon"
                            placeholder="Wpisz REGON firmy"
                            v-model="regon"
                        />
                        <div v-show="errors.regon" class="control__error">
                            <div class="control__error-inner">
                                {{errors.regon}}
                            </div>
                        </div>
                    </div>
                </div>

  
                <div class="buttons">
                    <button class="button-outline" @click.prevent="saveCompanyColumn">
                        <template v-if="!isLoading">
                            {{$t('profile.button_label')}}
                        </template>
                        <template v-else>
                            {{$t('profile.updating')}}...
                        </template>

                    </button>
                </div>
            </div>
        </form>
    </div>

</template>

<script>
import axios from "axios";
import authHelper from "@/helpsers/auth.helper";
import {useAuthStore} from "@/stores/auth.store";
import {inject, ref} from "vue";
import ApiHelper from "@/helpsers/api.helper";
import loader from '@/components/loader/index'
import {useField, useForm} from "vee-validate";
import * as yup from "yup";
import {useI18n} from "vue-i18n";
import AlertHelper from "@/helpsers/alert.helper";

export default {
    name: "CompanyData",
    components: {
        loader
    },
    setup() {
        const authStore = useAuthStore();
        let alert = inject('alert');
        const {t} = useI18n();
        const isLoading = ref(false)

        const { handleSubmit, errors } = useForm({
            validationSchema: yup.object().shape({
                company: yup.string().trim(),
                address: yup.string().trim(),
                city: yup.string().trim(),
                zipCode: yup.string()
                    .matches(/^[0-9]{2}-[0-9]{3}/,t('profile.company.validation.zip_code'))
                    .trim(),
                nip: yup.string()
                    .min(10,t('profile.company.validation.max_nip'))
                    .max(10, t('profile.company.validation.max_nip')),
                regon: yup.string(),
                    // .min(9,t('profile.company.validation.max_regon'))
                    // .max(9,t('profile.company.validation.max_regon')),
                province: yup.string(t('profile.company.validation.province')).trim(),
            }),
            initialValues: {
                company: authStore.userInfo?.company?.name ?? '',
                address: authStore.userInfo?.company?.address ?? '',
                city: authStore.userInfo?.company?.city ?? '',
                zipCode: authStore.userInfo?.company?.zipCode ?? '',
                nip: authStore.userInfo?.company?.nip ?? '',
                regon: authStore.userInfo?.company?.regon ?? '',
                province: authStore.userInfo?.company?.province ?? '',
            }
        });

        const { value: company } = useField('company');
        const { value: address} = useField('address');
        const { value: city } = useField('city');
        const { value: zipCode } = useField('zipCode');
        const { value: nip } = useField('nip');
        const { value: regon } = useField('regon');
        const { value: province } = useField('province');


        const saveCompanyColumn = handleSubmit(async () => {
            {
                isLoading.value = true;

                const data = {
                    companyName: company.value,
                    companyAddress: address.value,
                    companyCity: city.value,
                    companyZipCode: zipCode.value,
                    companyNip: nip.value,
                    companyRegon: regon.value,
                    companyProvince: province.value,
                }

                axios.put(ApiHelper.getUpdateUserUrl(), data, {
                    headers: authHelper.authHeader()
                }).then(response => {
                    isLoading.value = false;

                    AlertHelper.show(alert, t('profile.company.update_success'));

                    authStore.userInfo.company.company = company.value;
                    authStore.userInfo.company.address = address.value;
                    authStore.userInfo.company.city = city.value;
                    authStore.userInfo.company.zipCode = zipCode.value;
                    authStore.userInfo.company.nip = nip.value;
                    authStore.userInfo.company.regon = regon.value;
                    authStore.userInfo.company.province = province.value;

                }).catch(errorResponse => {
                    isLoading.value = false;

                    let errorMessage = ApiHelper.getResponseMessage(errorResponse.response?.data?.code);
                    AlertHelper.show(alert, errorMessage, '', 'error');

                })
            }
        });

        return {
            saveCompanyColumn,authStore, errors,
            address, company, city,zipCode,nip,regon,province,
            isLoading,
        }

    }
}
</script>

<style scoped>

</style>